import { ImagesApp } from '../../constants/images';
import { ReusableLinks } from '../../constants/reusableLinks';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Styles from './styles.publicity';

const Publicity = () => {
  const { translate } = useI18nContext();

  const handleRedirect = (store: string) => {
    window.open(ReusableLinks[store], '_blank');
  };

  return (
    <Styles.ContainerPublicity>
      <Styles.WrapperPublicity>
        <Styles.TitlePublicity>
          {translate(['INFORMATION', 'DOWNLOAD_APP_TO_ACCESS_TICKET'])}
        </Styles.TitlePublicity>
        <Styles.SubtitlePublicity>
          {translate(['INFORMATION', 'TICKET_GENERATED_SECURELY_IN_APP'])}
        </Styles.SubtitlePublicity>
      </Styles.WrapperPublicity>

      <Styles.ContainerStore>
        <Styles.Store src={ImagesApp.svg.appleStore} alt="" onClick={() => handleRedirect('AppStore')}/>
        <Styles.Store src={ImagesApp.svg.playStore} alt="" onClick={() => handleRedirect('GooglePlay')}/>
      </Styles.ContainerStore>

    </Styles.ContainerPublicity>
  );
};

export default Publicity;
